<template>
  <div class="dashboard-page">
    <PageLoader :storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#427D2D" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #fff">{{ msg }}</span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #fff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-container fluid class="px-4 py-0">
      <v-layout wrap justify-center pt-2>
        <v-flex xs12>
          <v-layout wrap justify-start>
            <v-flex
              v-for="(card, index) in cards"
              :key="index"
              xs12
              sm6
              md4
              lg3
              pa-3
            >
                            <v-card elevation="0" rounded="lg" :class="['stat-card', `card-idx-${index}`]">
                <div class="pa-5 d-flex align-center fill-height" style="background: transparent;">
                  <div :class="['icon-badge', `badge-idx-${index}`]" class="mr-4 flex-grow-0 flex-shrink-0">
                    <v-icon size="28" :class="[`icon-idx-${index}`]">{{ card.mdiIcon }}</v-icon>
                  </div>
                  <div class="d-flex flex-column justify-center text-start" style="min-width: 0; flex: 1; z-index: 2;">
                    <div class="card-title-container">
                      <span class="detailshead">{{ card.title }}</span>
                    </div>
                    <span class="value pt-1 pb-1">{{ card.value }}</span>
                    <div class="d-flex justify-start">
                      <span
                        class="action-link"
                        @click="redirectToPage(card.action, card.title)"
                      >
                        {{ card.action }}
                        <v-icon small class="action-icon ml-1">mdi-arrow-right</v-icon>
                      </span>
                    </div>
                  </div>
                </div>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout wrap justify-start class="d-flex align-stretch">
        <v-flex xs12 lg6 pa-3 class="d-flex">
          <v-card elevation="0" class="chart-card card-cases d-flex flex-column justify-space-between fill-height pa-5" style="width: 100%;">
            <div style="width: 100%;">
              <v-layout wrap justify-start>
                <v-flex xs12 lg9>
                  <div class="d-flex align-center">
                    <v-icon color="#de520c" class="mr-2 mb-1" size="26">mdi-chart-timeline-variant</v-icon>
                    <span class="reportone">Total Cases Overview</span>
                  </div>
                </v-flex>
                <v-flex xs12 lg3>
                  <v-select
                    outlined
                    dense
                    rounded
                    color="#de520c"
                    :hide-details="true"
                    :items="yearitems"
                    v-model="lineyeardata"
                    class="year-select"
                  ></v-select>
                </v-flex>
              </v-layout>
            </div>
            <div style="width: 100%;" class="pt-2 flex-grow-1 d-flex align-center">
              <div class="chart-container" v-if="flag1">
                <highcharts :options="histogramOptions" class="cases-chart"></highcharts>
              </div>
            </div>
          </v-card>
        </v-flex>
        <v-flex xs12 lg6 pa-3 class="d-flex">
          <v-card elevation="0" class="chart-card card-species d-flex flex-column justify-space-between fill-height pa-5" style="width: 100%;">
            <div style="width: 100%;">
              <div class="d-flex align-center">
                <v-icon color="#eab308" class="mr-2 mb-1" size="26">mdi-chart-donut</v-icon>
                <span class="reportone" style="font-size: 14px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">Top Common Snake Species</span>
              </div>
            </div>
            <div style="width: 100%;" class="pt-2 flex-grow-1 d-flex align-center">
              <div class="chart-container" v-if="flag" style="width: 100%;">
                <highcharts
                  :options="highchartsOptions"
                  :constructor-type="'chart'"
                  class="species-chart"
                ></highcharts>
              </div>
            </div>
            <div style="width: 100%;" class="pt-4 text-center" v-if="flag">
              <span @click="redirectToSnakeDetails()" class="leaderboard-view-more">
                View All Species
                <v-icon small class="ml-1" color="#de520c">mdi-arrow-right</v-icon>
              </span>
            </div>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout wrap justify-start pt-4>
        <v-flex xs12 pa-3>
          <v-card elevation="0" class="chart-card card-leaderboard pa-5">
            <div class="leaderboard-header d-flex align-center justify-space-between flex-wrap">
              <div class="d-flex align-center">
                <v-icon color="#de520c" class="mr-2 mb-1" size="26">mdi-trophy-outline</v-icon>
                <div>
                  <span class="reportone">Top Rescuers of the Year {{ currentYear }}</span>
                  <div
                    v-if="topusers && topusers.length > 0"
                    class="leaderboard-subtitle"
                  >
                    {{ topusers.length }} rescuer{{ topusers.length === 1 ? '' : 's' }} ranked by total rescues
                  </div>
                </div>
              </div>
              <span
                v-if="topusers && topusers.length > 0"
                class="leaderboard-view-more"
                @click="redirectToUsersDetails()"
              >
                View More
                <v-icon small class="ml-1">mdi-arrow-right</v-icon>
              </span>
            </div>

            <div v-if="topusers && topusers.length > 0" class="leaderboard-grid pt-4">
              <div
                v-for="(item, index) in topusers"
                :key="(item.user && item.user.name ? item.user.name : 'rescuer') + '-' + index"
                :class="['leaderboard-card', `rank-${index + 1}`]"
                @click="redirectToUsersDetails()"
              >
                <div class="rank-badge">
                  <v-icon v-if="index === 0" size="28" color="white">mdi-trophy</v-icon>
                  <v-icon v-else-if="index === 1" size="28" color="white">mdi-medal</v-icon>
                  <v-icon v-else-if="index === 2" size="28" color="white">mdi-medal-outline</v-icon>
                  <span v-else>#{{ index + 1 }}</span>
                </div>
                <div class="leaderboard-info" v-if="item && item.user && item.user.name">
                  <div class="rank-label">{{ getRankLabel(index) }}</div>
                  <div class="rescuername">{{ item.user.name }}</div>
                </div>
                <div class="rescuer-stat">
                  <span class="rescuer-stat-value">{{ item.count || 0 }}</span>
                  <span class="rescuer-stat-label">Rescues</span>
                </div>
              </div>
            </div>

            <div v-else class="leaderboard-empty">
              <v-icon size="52" color="#cbd5e1">mdi-account-group-outline</v-icon>
              <span class="leaderboard-empty-title">No rescuer data yet</span>
              <span class="leaderboard-empty-text">Top performers will appear here once rescues are recorded.</span>
            </div>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout wrap justify-center>
        <!-- <v-flex xs12>
          <v-layout wrap justify-start>
            <v-flex
              v-for="(date, index) in dates"
              :key="index"
              xs12
              md4
              sm4
              lg3
              pa-3
            >
              <v-card>
                <v-layout wrap justify-center pa-5>
                  <v-flex xs6 class="text-start">
                    <v-icon color="red">mdi-calendar</v-icon
                    ><span style="font-size: 17px; color: red">{{
                      date.year
                    }}</span>
                  </v-flex>
                  <v-flex xs6 class="text-end value">
                    <span style="font-size: 20px">{{ date.count }}</span>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex> -->
      </v-layout>
      <v-layout wrap justify-center>
      <!-- <v-flex xs12>
        <v-layout wrap justify-start>
          <v-flex xs12 md4 sm4 lg4 pa-3>
            <v-card elevation="1">
              <v-layout wrap justify-center>
                <v-flex xs12 pa-5>
                  <v-layout wrap pb-2>
                    <v-flex xs1>
                      <span
                        ><v-icon small color="yellow"
                          >mdi-rotate-right-variant</v-icon
                        ></span
                      >
                    </v-flex>
                    <v-flex xs11>
                      <span class="detailshead">Most Common Snakes - 2024</span>
                    </v-flex>
                  </v-layout>
                  <v-divider></v-divider>
                </v-flex>
                <v-flex xs12 px-5>
                  <v-simple-table>
                    <template v-slot:default>
                      <tbody>
                        <tr v-for="item in topsnakes" :key="item.id || 'na'">
                          <td class="listvalue">{{ item.snake ? item.snake.name : 'N/A' }}</td>
                          <td>{{ item.count }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  <v-divider></v-divider>
                </v-flex>
                <v-flex xs12 pa-5>
                  <v-layout wrap justify-center>
                    <v-flex xs12 class="text-center">
                      <span
                        class="viewmore"
                        @click="redirectToSnakeDetails()"
                        style="cursor: pointer"
                        >View More</span
                      >
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex xs12 md4 sm4 lg4 pa-3>
            <v-card elevation="1">
              <v-layout wrap justify-center>
                <v-flex xs12 pa-5>
                  <v-layout pb-2>
                    <v-flex xs1>
                      <span
                        ><v-icon small color="green"
                          >mdi-account-check</v-icon
                        ></span
                      >
                    </v-flex>
                    <v-flex xs11>
                      <span class="detailshead"
                        >Top Rescuers of {{ currentMonth }}</span
                      >
                    </v-flex>
                  </v-layout>
                  <v-divider></v-divider>
                </v-flex>
                <v-flex xs12 px-5>
                  <v-simple-table>
                    <template v-slot:default>
                      <tbody>
                        <tr v-for="item in topusers" :key="item.name">
                          <td class="listvalue">{{ item.user.name }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  <v-divider></v-divider>
                </v-flex>
                <v-flex xs12 pa-5>
                  <v-layout wrap justify-center>
                    <v-flex xs12 class="text-center">
                      <span
                        class="viewmore"
                        @click="redirectToUsersDetails()"
                        style="cursor: pointer"
                        >View More</span
                      >
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex xs12 md4 sm4 lg4 pa-3>
            <v-card elevation="1">
              <v-layout wrap justify-center>
                <v-flex xs12 pa-5>
                  <v-layout pb-2>
                    <v-flex xs1>
                      <span
                        ><v-icon small color="blue">
                          mdi-human-child</v-icon
                        ></span
                      >
                    </v-flex>
                    <v-flex xs11>
                      <span class="detailshead"
                        >Top Rescuers of {{ currentYear }}</span
                      >
                    </v-flex>
                  </v-layout>
                  <v-divider></v-divider>
                </v-flex>
                <v-flex xs12 px-5>
                  <v-simple-table>
                    <template v-slot:default>
                      <tbody>
                        <tr v-for="item in topusers" :key="item.name">
                          <td class="listvalue">{{ item.user.name }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  <v-divider></v-divider>
                </v-flex>
                <v-flex xs12 pa-5>
                  <v-layout wrap justify-center>
                    <v-flex xs12 class="text-center">
                      <span
                        class="viewmore"
                        @click="redirectToUsersyearDetails()"
                        style="cursor: pointer"
                        >View More</span
                      >
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex> -->
    </v-layout>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.toLocaleString("default", {
      month: "long",
    });
    // Create an array containing the last 5 years (e.g. [2022, 2023, 2024, 2025, 2026])
    const yearitems = Array.from({ length: 5 }, (_, i) => currentYear - 4 + i);
    return {
      currentYear,
      currentMonth,
      yearitems,
      lineyeardata: currentYear,
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      pages: 0,
      count: 20,
      cards: [
        {
          title: "Total Users",
          value: 0,
          action: "View Map",
          icon: require("@/assets/images/totalusers.png"),
          mdiIcon: "mdi-account-group-outline",
          vert:require("@/assets/images/redvertical.png"),
          color: "green",
        },
        {
          title: "Snake Rescuers",
          value: 0,
          action: "View Map",
          icon: require("@/assets/images/icon_snake.png"),
          mdiIcon: "mdi-account-hard-hat",
          vert:require("@/assets/images/purplevert.png"),
          color: "blue",
        },
        {
          title: "Snakes Rescued",
          value: 0,
          action: "View Map",
          icon: require("@/assets/images/snakeresc.png"),
          mdiIcon: "mdi-hand-heart-outline",
          vert:require("@/assets/images/yellowvert.png"),
          color: "red",
        },
        {
          title: "Identification Help",
          value: 0,
          action: "View Details",
          icon: require("@/assets/images/idhelp.png"),
          mdiIcon: "mdi-help-circle-outline",
          vert:require("@/assets/images/bluevert.png"),
          color: "yellow",
        },
        {
          title: "Listed Hospitals",
          value: 0,
          action: "View Map",
          icon: require("@/assets/images/listhosp.png"),
          mdiIcon: "mdi-hospital-building",
          vert:require("@/assets/images/greenvert.png"),
          color: "red",
        },
        {
          title: "Snake Bite cases",
          value: 0,
          action: "View Details",
          icon: require("@/assets/images/snakedeath.png"),
          mdiIcon: "mdi-heart-pulse",
          vert:require("@/assets/images/greyvert.png"),
          color: "yellow",
        },
        {
          title: "Listed Snakes",
          value: 0,
          action: "View Details",
          icon: require("@/assets/images/listedsnakes.png"),
          mdiIcon: "mdi-snake",
          vert:require("@/assets/images/pinkvert.png"),
          color: "light-green",
        },
        {
          title: "Public users",
          value: 0,
          action: "View Details",
          icon: require("@/assets/images/publicusers.png"),
          mdiIcon: "mdi-account-network-outline",
          vert:require("@/assets/images/orangevert.png"),
          color: "purple",
        },
        {
          title: "Total Reports",
          value: 0,
          action: "View Details",
          icon: require("@/assets/images/dash1.png"),
          mdiIcon: "mdi-file-document-multiple-outline",
          vert: require("@/assets/images/bluevert.png"),
          color: "blue",
        },
        {
          title: "Completed Reports",
          value: 0,
          action: "View Details",
          icon: require("@/assets/images/dash2.png"),
          mdiIcon: "mdi-check-all",
          vert: require("@/assets/images/greenvert.png"),
          color: "green",
        },
        // {
        //   title: "Total Snake Rescues",
        //   value: 0,
        //   action: "View Details",
        //   icon: require("@/assets/images/dash3.png"),
        //   mdiIcon: "mdi-snake",
        //   vert: require("@/assets/images/yellowvert.png"),
        //   color: "yellow",
        // },
        {
          title: "Snakes Escaped",
          value: 0,
          action: "View Details",
          icon: require("@/assets/images/dash4.png"),
          mdiIcon: "mdi-run-fast",
          vert: require("@/assets/images/greyvert.png"),
          color: "grey",
        },


      ],
      dates: [],
      details: [
        { title: "Most Common Snakes - 2024", icon: "mdi-snake" },
        { title: "Top Rescuers of July", icon: "mdi-snake" },
        { title: "Top Rescuers of 2024", icon: "mdi-snake" },
      ],
      topsnakes: [],
      topusers: [],
      chartOptions3: {
        chart: {
          height: 262,
          type: "bar",
        },
        plotOptions: {
          bar: {
            columnWidth: "45%",
            distributed: true,
          },
        },
        dataLabels: {
          enabled: true,
        },
        legend: {
          show: false,
        },
        xaxis: {
          categories: [],
          labels: {
            style: {
              fontSize: "12px",
            },
          },
          title: {
            text: "Year",
          },
        },
        yaxis: {
          title: {
            text: "Count",
          },
        },
      },
      series3: [
        {
          name: "Count",
          data: [],
        },
      ],
      // yearitems: ["Last 7 Years", "Last 5 Years"],
      // lineyeardata: "Last 5 Years",
      options: {
        chart: {
          type: "donut",
        },
        labels: [], // For the animal names
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },
      series: [],
      flag: false,
      flag1: false,
      yearwiseData: [],
      histogramOptions: {
        chart: {
          type: "areaspline",
          height: 320,
          backgroundColor: "transparent",
          style: {
            fontFamily: "poppinsregular, sans-serif",
          },
          spacing: [10, 10, 15, 10],
        },
        title: { text: null },
        exporting: { enabled: false },
        xAxis: {
          categories: [],
          crosshair: {
            width: 1,
            color: "rgba(222, 82, 12, 0.15)",
          },
          title: {
            text: "Month",
            style: {
              color: "#94a3b8",
              fontFamily: "poppinsmedium, sans-serif",
              fontSize: "12px",
              fontWeight: "500",
            },
          },
          labels: {
            style: {
              color: "#64748b",
              fontFamily: "poppinsmedium, sans-serif",
              fontSize: "12px",
            },
          },
          lineColor: "rgba(15, 23, 42, 0.06)",
          tickColor: "transparent",
        },
        credits: { enabled: false },
        yAxis: {
          min: 0,
          allowDecimals: false,
          title: {
            text: "Total Cases",
            style: {
              color: "#94a3b8",
              fontFamily: "poppinsmedium, sans-serif",
              fontSize: "12px",
              fontWeight: "500",
            },
          },
          labels: {
            style: {
              color: "#64748b",
              fontFamily: "poppinsmedium, sans-serif",
              fontSize: "12px",
            },
          },
          gridLineColor: "rgba(15, 23, 42, 0.04)",
          gridLineDashStyle: "Dash",
        },
        legend: { enabled: false },
        tooltip: {
          shared: true,
          backgroundColor: "rgba(15, 23, 42, 0.92)",
          borderWidth: 0,
          borderRadius: 10,
          shadow: true,
          style: {
            color: "#ffffff",
            fontFamily: "poppinsmedium, sans-serif",
            fontSize: "13px",
          },
          headerFormat: '<span style="font-size:11px;color:#94a3b8">{point.key}</span><br/>',
          pointFormat: '<span style="color:#fb923c">\u25CF</span> {series.name}: <b>{point.y}</b>',
        },
        plotOptions: {
          areaspline: {
            fillOpacity: 1,
            lineWidth: 2.5,
            marker: {
              enabled: true,
              radius: 4,
              fillColor: "#ffffff",
              lineWidth: 2,
              lineColor: "#de520c",
              states: {
                hover: { radius: 6, lineWidth: 2.5 },
              },
            },
            states: {
              hover: { lineWidth: 3 },
            },
            dataLabels: {
              enabled: true,
              formatter: function () {
                return this.y > 0 ? this.y : null;
              },
              style: {
                color: "#0f172a",
                textOutline: "none",
                fontFamily: "poppinssemibold, sans-serif",
                fontSize: "11px",
                fontWeight: "600",
              },
              y: -8,
            },
          },
          series: {
            animation: { duration: 900 },
          },
        },
        series: [
          {
            name: "Reports",
            data: [],
            color: "#de520c",
            fillColor: {
              linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
              stops: [
                [0, "rgba(222, 82, 12, 0.28)"],
                [1, "rgba(222, 82, 12, 0.02)"],
              ],
            },
          },
        ],
        responsive: {
          rules: [{
            condition: { maxWidth: 600 },
            chartOptions: {
              chart: { height: 280 },
              xAxis: {
                labels: { style: { fontSize: "10px" } },
              },
              yAxis: {
                labels: { style: { fontSize: "10px" } },
              },
            },
          }],
        },
      },
      highchartsOptions: {
        chart: {
          type: "pie",
          height: 360,
          backgroundColor: "transparent",
          style: {
            fontFamily: "poppinsregular, sans-serif",
          },
          events: {
            // center text removed
          },
        },
        colors: [
          "#de520c",
          "#3b82f6",
          "#f59e0b",
          "#14b8a6",
          "#64748b",
          "#8b5cf6",
          "#22c55e",
          "#ec4899",
          "#ef4444",
          "#06b6d4",
        ],
        credits: { enabled: false },
        title: { text: null },
        exporting: { enabled: false },
        tooltip: {
          pointFormat: "<b>{point.percentage:.1f}%</b>",
          backgroundColor: "rgba(15, 23, 42, 0.92)",
          borderWidth: 0,
          borderRadius: 10,
          shadow: true,
          style: {
            color: "#ffffff",
            fontFamily: "poppinsmedium, sans-serif",
            fontSize: "13px",
          },
        },
        legend: {
          enabled: false,
          layout: "vertical",
          align: "right",
          verticalAlign: "middle",
          itemMarginTop: 6,
          itemMarginBottom: 6,
          symbolPadding: 8,
          itemStyle: {
            fontWeight: "500",
            fontFamily: "poppinsmedium, sans-serif",
            color: "#475569",
            fontSize: "11px",
          },
          itemHoverStyle: { color: "#de520c" },
          labelFormatter: function () {
            return (
              '<div style="display: flex; justify-content: space-between; width: 170px;">' +
              '<span style="font-weight:600; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 120px;">' +
              this.name +
              '</span> <span style="color:#94a3b8; font-size:10px; text-align: right; min-width: 45px;">' +
              this.y + ' (' +
              this.percentage.toFixed(0) +
              "%)</span></div>"
            );
          },
          symbolRadius: 4,
          symbolHeight: 10,
          symbolWidth: 10,
          useHTML: true,
        },
        accessibility: {
          point: { valueSuffix: "%" },
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            borderRadius: 0,
            borderWidth: 1.5,
            borderColor: "#ffffff",
            size: "85%",
            innerSize: "45%",
            showInLegend: true,
            dataLabels: {
              enabled: true,
              distance: -20,
              format: '{point.percentage:.0f}%',
              style: {
                color: '#ffffff',
                textOutline: 'none',
                fontWeight: '600',
                fontSize: '10px',
                fontFamily: "poppinsmedium, sans-serif",
              }
            },
            states: {
              hover: {
                halo: {
                  size: 10,
                  opacity: 0.25,
                },
              },
              select: {
                color: null,
                borderColor: "#ffffff",
              },
            },
          },
          series: {
            animation: { duration: 900 },
          },
        },
        series: [
          {
            name: "Species",
            colorByPoint: true,
            data: [],
          },
        ],
        responsive: {
          rules: [{
            condition: { maxWidth: 600 },
            chartOptions: {
              chart: { height: 300 },
              legend: {
                layout: "horizontal",
                align: "center",
                verticalAlign: "bottom",
                itemMarginTop: 6,
                itemMarginBottom: 0,
              },
              plotOptions: {
                pie: { size: "70%", innerSize: "62%" },
              },
            },
          }],
        },
      },
      seriesData: [],
    };
  },
  beforeMount() {
    this.countData();
    this.yearData();
    // Pie chart is populated from countData() to ensure uniform counts
  },
  watch: {
    lineyeardata() {
      this.yearData();
    },
  },
  methods: {
    redirectToSnakeDetails() {
      this.$router.push({ path: "/topcommonsnakes" });
    },
    // animalcountData() {
    //   this.appLoading = true;
    //   axios({
    //     method: "GET",
    //     url: "/hwc/animalsummary/reports",
    //     headers: {
    //       "x-auth-token": localStorage.getItem("token"),
    //     },
    //   })
    //     .then((response) => {
    //       if (response.data.status == true) {
    //         const animalReportSummary = response.data.data.animalReportSummary;
    //         this.series = animalReportSummary.map((item) => item.totalReports);
    //         this.options.labels = animalReportSummary.map((item) => item.name);
    //         this.totalconflictdata = response.data.data.totalReports;
    //         const seriesData = animalReportSummary.map((item) => ({
    //           name: item.name,
    //           y: item.totalReports,
    //         }));
    //         this.highchartsOptions.series[0].data = seriesData;
    //         this.flag = true;
    //         this.appLoading = false;
    //       } else {
    //         this.msg = response.data.msg;
    //         this.showSnackBar = true;
    //         this.appLoading = false;
    //       }
    //     })
    //     .catch((err) => {
    //       this.appLoading = false;
    //       this.ServerError = true;
    //       console.log(err);
    //     });
    // },
    topsnakesData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/topsnakes/all",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            const animalReportSummary = response.data.data.allSnakes.slice(0,10);
            console.log("Data", animalReportSummary);
            this.series = animalReportSummary.map((item) => item.count);
            this.options.labels = animalReportSummary.map((item) => item.snakeName);
            const seriesData = animalReportSummary.map((item) => ({
              name: item.snakeName,
              y: item.count,
            }));
            this.highchartsOptions.series[0].data = seriesData;
            this.flag = true;
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.appLoading = false;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    redirectToPage(action, title) {
      if (title === "Total Users") {
        this.$router.push({ path: "/usermap" });
      } else if (title === "Snake Rescuers") {
        this.$router.push({ path: "/rescuermap" });
      } else if (title === "Snakes Rescued") {
        this.$router.push({ path: "/snakerescued" });
      } else if (title === "Identification Help") {
        this.$router.push({ path: "/identificationhelp" });
      } else if (title === "Listed Hospitals") {
        this.$router.push({ path: "/hospitalMap" });
      } else if (title === "Snake Bite cases") {
        this.$router.push({ path: "/snakeBite" });
      } else if (title === "Listed Snakes") {
        this.$router.push({ path: "/listedSnakes" });
      } else if (title === "Public users") {
        this.$router.push({ path: "/usersList" });
      } else if (title === "Total Reports" || title === "Completed Reports" || title === "Snakes Escaped") {
        this.$router.push({ path: "/snakereports" });
      }
    },

    redirectToUsersDetails() {
      this.$router.push({ path: "/topUsers" });
    },
    getRankLabel(index) {
      const labels = ["1st Place", "2nd Place", "3rd Place"];
      return labels[index] || `Rank #${index + 1}`;
    },
    redirectToUsersyearDetails() {
      this.$router.push({ path: "/topUsersyear" });
    },
    countData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/stats",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            {
              this.cards[0].value = response.data.data.count_total_users;
              this.cards[1].value = response.data.data.count_total_rescuer;
              this.cards[2].value = response.data.data.count_total_locations;
              this.cards[3].value = response.data.data.count_identify;
              this.cards[4].value = response.data.data.count_hospital;
              this.cards[5].value = response.data.data.count_management;
              this.cards[6].value = response.data.data.count_snakes;
              this.cards[7].value = response.data.data.count_users;
              this.cards[8].value = response.data.data.count_total_reports || 0;
              this.cards[9].value = response.data.data.count_report_rescued || 0;
              // this.cards[10].value = response.data.data.count_snake_rescued || 0;
              this.cards[10].value = response.data.data.count_snake_escaped || 0;
              this.topsnakes = response.data.data.topsnakes;
              // Populate pie chart from the same /user/stats data to ensure uniform count
              if (this.topsnakes && this.topsnakes.length > 0) {
                const animalReportSummary = this.topsnakes.slice(0, 10);
                this.series = animalReportSummary.map((item) => item.count);
                this.options.labels = animalReportSummary.map((item) => item.snake ? item.snake.name : 'N/A');
                const seriesData = animalReportSummary.map((item) => ({
                  name: item.snake ? item.snake.name : 'N/A',
                  y: item.count,
                }));
                this.highchartsOptions.series[0].data = seriesData;
                this.flag = true;
              }
              this.topusers = response.data.data.topusers;
              this.appLoading = false;
            }
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.appLoading = false;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          (this.ServerError = true), console.log(err);
        });
    },

    
    // yearData() {
    //   this.appLoading = true;
    //   const yearMapping = {
    //     "Last 7 Years": 7,
    //     "Last 5 Years": 5,
    //   };
    //   const selectedYears = yearMapping[this.lineyeardata] || 5;
    //   axios({
    //     method: "GET",
    //     url: "/user/yearwise",
    //     headers: {
    //       "x-auth-token": localStorage.getItem("token"),
    //     },
    //     params: {
    //       year: selectedYears,
    //     },
    //   })
    //     .then((response) => {
    //       // console.log("Response data:", response.data);
    //       if (response.data.status == true) {
    //         {
    //           // const yearwiseData = response.data.data;
    //           // this.chartOptions3.xaxis.categories = yearwiseData.map(item => item.year);
    //           // this.series3[0].data = yearwiseData.map(item => item.count);
    //           this.yearwiseData = response.data.data;
    //           this.histogramOptions.xAxis.categories = this.yearwiseData.map(
    //             (item) => item.year
    //           );
    //           this.histogramOptions.series[0].data = this.yearwiseData.map(
    //             (item) => item.count
    //           );
    //           this.flag1 = true;
    //           this.dates = response.data.data;
    //           this.appLoading = false;
    //         }
    //       } else {
    //         this.msg = response.data.msg;
    //         this.showSnackBar = true;
    //         this.appLoading = false;
    //       }
    //     })
    //     .catch((err) => {
    //       this.appLoading = false;
    //       (this.ServerError = true), console.log(err);
    //     });
    // },

    yearData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/monthwise",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          year: this.lineyeardata, // Sends the selected year (e.g. 2026)
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            this.yearwiseData = response.data.data;

            // Map 'month' values (Jan, Feb, etc.) to categories
            this.histogramOptions.xAxis.categories = this.yearwiseData.map(
              (item) => item.month
            );

            // Map the case count for each month
            this.histogramOptions.series[0].data = this.yearwiseData.map(
              (item) => item.count
            );

            this.flag1 = true;
            this.dates = response.data.data;
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.appLoading = false;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

  },
};
</script>
<style scoped>
.dashboard-page {
  background-color: #fff7f2;
  min-height: 100vh;
  padding-bottom: 2rem;
}

.detailshead {
  font-family: poppinsmedium, sans-serif;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #64748b;
}
.value {
  font-family: poppinsbold, sans-serif;
  font-size: 32px;
  font-weight: 800;
  line-height: 38px;
  letter-spacing: -0.5px;
  color: #0f172a;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.03);
}
.listvalue {
  font-family: poppinsbold;
  font-size: 14px;
}
.sarpa {
  font-family: poppinsmedium;
  font-size: 20px;
  font-weight: 500;
}
.viewmore {
  font-family: poppinsmedium;
  font-size: 13px;
  color: #2563eb;
  text-decoration: none;
  transition: all 0.3s ease;
  font-weight: 600;
}
.viewmore:hover {
  color: #1d4ed8;
  text-decoration: underline;
}
.reportone {
  font-family: poppinsbold, sans-serif;
  font-size: 19px;
  font-weight: 700;
  line-height: 32px;
  letter-spacing: -0.3px;
  color: #0f172a;
}
.rescuername {
  font-family: poppinsmedium, sans-serif;
  font-size: 15px;
  font-weight: 600;
  color: #0f172a;
}
.rescuervalue {
  font-family: poppinsmedium;
  font-size: 14px;
  font-weight: 600;
  color: #de520c;
}
.viewdetails {
  font-family: poppinsmedium;
  font-size: 13px;
  font-weight: 500;
  color: #de520c;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s ease;
}
.viewdetails:hover {
  color: #b83e05;
  text-decoration: underline;
}

.viewdetails-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #de520c, #b83e05);
  color: white !important;
  font-family: poppinsmedium, sans-serif;
  font-size: 13px;
  font-weight: 600;
  padding: 8px 24px;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  box-shadow: 0 4px 12px rgba(222, 82, 12, 0.3);
}
.viewdetails-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(222, 82, 12, 0.45);
}

.reporttwo {
  font-family: poppinsmedium;
  font-weight: 500;
  font-size: 14px;
  color: #64748b;
}

/* Leaderboard Section */
.leaderboard-header {
  position: relative;
  z-index: 2;
  gap: 12px;
}

.leaderboard-subtitle {
  font-family: poppinsmedium, sans-serif;
  font-size: 12px;
  color: #64748b;
  margin-top: 2px;
}

.leaderboard-view-more {
  display: inline-flex;
  align-items: center;
  font-family: poppinsmedium, sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #de520c;
  cursor: pointer;
  transition: all 0.25s ease;
  white-space: nowrap;
}

.leaderboard-view-more:hover {
  color: #c2410c;
  text-decoration: underline;
}

.leaderboard-view-more:hover .v-icon {
  transform: translateX(3px);
}

/* Premium Leaderboard Card Design */
.leaderboard-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
  position: relative;
  z-index: 2;
}

.leaderboard-card {
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 16px;
  padding: 20px;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  box-shadow: 0 8px 32px rgba(15, 23, 42, 0.05);
  cursor: pointer;
  height: 100%;
  gap: 16px;
}

.leaderboard-card:hover {
  transform: translateY(-6px) scale(1.02);
  box-shadow: 0 15px 35px rgba(15, 23, 42, 0.1);
}

.leaderboard-card::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 50%;
  height: 100%;
  background: linear-gradient(
    90deg,
    rgba(255,255,255,0) 0%,
    rgba(255,255,255,0.4) 50%,
    rgba(255,255,255,0) 100%
  );
  transform: skewX(-25deg);
  transition: all 0.7s ease;
  z-index: 1;
}

.leaderboard-card:hover::after {
  left: 150%;
}

.rank-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #f1f5f9;
  color: #64748b;
  font-family: poppinsbold, sans-serif;
  font-size: 16px;
  flex-shrink: 0;
  box-shadow: inset 0 2px 4px rgba(255,255,255,0.8), 0 4px 10px rgba(0,0,0,0.05);
  transition: all 0.4s ease;
  z-index: 2;
}

.leaderboard-card:hover .rank-badge {
  transform: scale(1.1) rotate(5deg);
}

.leaderboard-info {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  z-index: 2;
}

.rank-label {
  font-family: poppinsbold, sans-serif;
  font-size: 11px;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: #94a3b8;
  margin-bottom: 4px;
}

.rescuername {
  font-family: poppinsbold, sans-serif;
  font-size: 16px;
  color: #1e293b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.rescuer-stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 64px;
  padding: 10px 12px;
  border-radius: 12px;
  background: rgba(241, 245, 249, 0.8);
  flex-shrink: 0;
  transition: all 0.3s ease;
  z-index: 2;
  border: 1px solid rgba(255,255,255,0.6);
}

.leaderboard-card:hover .rescuer-stat {
  background: rgba(222, 82, 12, 0.1);
  transform: translateY(-2px);
}

.rescuer-stat-value {
  font-family: poppinsbold, sans-serif;
  font-size: 22px;
  color: #0f172a;
  line-height: 1;
}

.rescuer-stat-label {
  font-family: poppinsmedium, sans-serif;
  font-size: 11px;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: -2px;
  margin-top: 4px;
}

.leaderboard-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 48px 24px;
  position: relative;
  z-index: 2;
}

.leaderboard-empty-title {
  font-family: poppinssemibold, sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #334155;
  margin-top: 12px;
}

.leaderboard-empty-text {
  font-family: poppinsmedium, sans-serif;
  font-size: 13px;
  color: #94a3b8;
  margin-top: 6px;
  max-width: 320px;
}

/* Premium Top 3 Styles */
/* 1st Place - Gold */
.rank-1 {
  background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%) !important;
  border: 1px solid #fde68a;
  box-shadow: 0 10px 30px rgba(251, 191, 36, 0.15);
}
.rank-1 .rank-badge {
  background: linear-gradient(135deg, #f59e0b 0%, #b45309 100%);
  color: #fff;
  box-shadow: 0 6px 15px rgba(245, 158, 11, 0.4);
}
.rank-1 .rank-label { color: #d97706; }
.rank-1 .rescuername { color: #78350f; }
.rank-1 .rescuer-stat {
  background: rgba(251, 191, 36, 0.2);
  border-color: rgba(251, 191, 36, 0.4);
}
.rank-1:hover {
  box-shadow: 0 15px 40px rgba(251, 191, 36, 0.25);
  border-color: #f59e0b;
}

/* 2nd Place - Silver */
.rank-2 {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%) !important;
  border: 1px solid #e2e8f0;
  box-shadow: 0 10px 30px rgba(148, 163, 184, 0.15);
}
.rank-2 .rank-badge {
  background: linear-gradient(135deg, #94a3b8 0%, #475569 100%);
  color: #fff;
  box-shadow: 0 6px 15px rgba(148, 163, 184, 0.4);
}
.rank-2 .rank-label { color: #64748b; }
.rank-2 .rescuername { color: #1e293b; }
.rank-2 .rescuer-stat {
  background: rgba(148, 163, 184, 0.15);
  border-color: rgba(148, 163, 184, 0.3);
}
.rank-2:hover {
  box-shadow: 0 15px 40px rgba(148, 163, 184, 0.25);
  border-color: #94a3b8;
}

/* 3rd Place - Bronze */
.rank-3 {
  background: linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%) !important;
  border: 1px solid #fed7aa;
  box-shadow: 0 10px 30px rgba(249, 115, 22, 0.15);
}
.rank-3 .rank-badge {
  background: linear-gradient(135deg, #f97316 0%, #c2410c 100%);
  color: #fff;
  box-shadow: 0 6px 15px rgba(249, 115, 22, 0.4);
}
.rank-3 .rank-label { color: #ea580c; }
.rank-3 .rescuername { color: #7c2d12; }
.rank-3 .rescuer-stat {
  background: rgba(249, 115, 22, 0.15);
  border-color: rgba(249, 115, 22, 0.3);
}
.rank-3:hover {
  box-shadow: 0 15px 40px rgba(249, 115, 22, 0.25);
  border-color: #f97316;
}

/* Stat Card Base */
.stat-card {
  background-color: #ffffff !important;
  border: 1px solid rgba(15, 23, 42, 0.08) !important;
  border-radius: 14px !important;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.9),
    0 1px 3px rgba(15, 23, 42, 0.05),
    0 6px 22px rgba(15, 23, 42, 0.07) !important;
  transition: all 0.35s cubic-bezier(0.25, 0.8, 0.25, 1) !important;
  cursor: pointer;
  position: relative;
}

.stat-card:hover {
  transform: translateY(-4px) !important;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.9),
    0 4px 10px rgba(15, 23, 42, 0.06),
    0 16px 34px rgba(15, 23, 42, 0.11) !important;
}

/* Icon badge container */
.icon-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 54px;
  height: 54px;
  border-radius: 14px;
  transition: all 0.35s cubic-bezier(0.25, 0.8, 0.25, 1) !important;
  z-index: 2;
  position: relative;
  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.07);
}

.stat-card:hover .icon-badge {
  transform: scale(1.05) !important;
  box-shadow: 0 5px 14px rgba(15, 23, 42, 0.11);
}

/* Text Styling */
.stat-card .detailshead {
  color: #64748b !important;
  font-family: poppinsmedium, sans-serif !important;
  font-size: 11.5px !important;
  letter-spacing: 0.5px;
  font-weight: 600;
  text-transform: uppercase;
  margin-bottom: 2px;
}

.stat-card .value {
  color: #0f172a !important;
  font-family: poppinssemibold, sans-serif !important;
  font-size: 28px !important;
  font-weight: 700;
  line-height: 1.1;
  letter-spacing: -0.5px;
}

/* Text Action Link */
.stat-card .action-link {
  display: inline-flex;
  align-items: center;
  color: #de520c !important;
  font-size: 13px !important;
  font-family: poppinsmedium, sans-serif !important;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease !important;
}
.stat-card .action-icon {
  color: #de520c !important;
  transition: all 0.2s ease !important;
}
.stat-card:hover .action-link {
  text-decoration: underline;
  color: #c2410c !important;
}
.stat-card:hover .action-icon {
  transform: translateX(4px);
  color: #c2410c !important;
}

/* Card borders — subtle tint, white bg */
.stat-card.card-idx-0 { background: #ffffff !important; border-color: rgba(244, 106, 42, 0.16) !important; }
.stat-card.card-idx-1 { background: #ffffff !important; border-color: rgba(249, 115, 22, 0.16) !important; }
.stat-card.card-idx-2 { background: #ffffff !important; border-color: rgba(239, 68, 68, 0.16) !important; }
.stat-card.card-idx-3 { background: #ffffff !important; border-color: rgba(14, 165, 233, 0.16) !important; }
.stat-card.card-idx-4 { background: #ffffff !important; border-color: rgba(168, 85, 247, 0.16) !important; }
.stat-card.card-idx-5 { background: #ffffff !important; border-color: rgba(249, 115, 22, 0.16) !important; }
.stat-card.card-idx-6 { background: #ffffff !important; border-color: rgba(236, 72, 153, 0.16) !important; }
.stat-card.card-idx-7 { background: #ffffff !important; border-color: rgba(249, 115, 22, 0.16) !important; }
.stat-card.card-idx-8 { background: #ffffff !important; border-color: rgba(99, 102, 241, 0.16) !important; }
.stat-card.card-idx-9 { background: #ffffff !important; border-color: rgba(34, 197, 94, 0.16) !important; }
.stat-card.card-idx-10 { background: #ffffff !important; border-color: rgba(239, 68, 68, 0.16) !important; }
.stat-card.card-idx-11 { background: #ffffff !important; border-color: rgba(100, 116, 139, 0.16) !important; }

.stat-card.card-idx-0:hover { border-color: rgba(244, 106, 42, 0.32) !important; }
.stat-card.card-idx-1:hover { border-color: rgba(249, 115, 22, 0.32) !important; }
.stat-card.card-idx-2:hover { border-color: rgba(239, 68, 68, 0.32) !important; }
.stat-card.card-idx-3:hover { border-color: rgba(14, 165, 233, 0.32) !important; }
.stat-card.card-idx-4:hover { border-color: rgba(168, 85, 247, 0.32) !important; }
.stat-card.card-idx-5:hover { border-color: rgba(249, 115, 22, 0.32) !important; }
.stat-card.card-idx-6:hover { border-color: rgba(236, 72, 153, 0.32) !important; }
.stat-card.card-idx-7:hover { border-color: rgba(249, 115, 22, 0.32) !important; }
.stat-card.card-idx-8:hover { border-color: rgba(99, 102, 241, 0.32) !important; }
.stat-card.card-idx-9:hover { border-color: rgba(34, 197, 94, 0.32) !important; }
.stat-card.card-idx-10:hover { border-color: rgba(239, 68, 68, 0.32) !important; }
.stat-card.card-idx-11:hover { border-color: rgba(100, 116, 139, 0.32) !important; }

/* Card Badge specific colors */
.badge-idx-0 { background: #ffeadd !important; }
.icon-idx-0 { color: #f46a2a !important; }

.badge-idx-1 { background: #ffebd6 !important; }
.icon-idx-1 { color: #f97316 !important; }

.badge-idx-2 { background: #fee2e2 !important; }
.icon-idx-2 { color: #ef4444 !important; }

.badge-idx-3 { background: #e0f2fe !important; }
.icon-idx-3 { color: #0ea5e9 !important; }

.badge-idx-4 { background: #f3e8ff !important; }
.icon-idx-4 { color: #a855f7 !important; }

.badge-idx-5 { background: #ffedd5 !important; }
.icon-idx-5 { color: #f97316 !important; }

.badge-idx-6 { background: #fce7f3 !important; }
.icon-idx-6 { color: #ec4899 !important; }

.badge-idx-7 { background: #ffedd5 !important; }
.icon-idx-7 { color: #f97316 !important; }

.badge-idx-8 { background: #e0e7ff !important; }
.icon-idx-8 { color: #6366f1 !important; }

.badge-idx-9 { background: #dcfce7 !important; }
.icon-idx-9 { color: #22c55e !important; }

.badge-idx-10 { background: #fee2e2 !important; }
.icon-idx-10 { color: #ef4444 !important; }

.badge-idx-11 { background: #f1f5f9 !important; }
.icon-idx-11 { color: #64748b !important; }


/* Chart containers */
.chart-container {
  width: 100%;
  position: relative;
  z-index: 2;
}

.cases-chart,
.species-chart {
  width: 100%;
}

/* Year selector styling */
.year-select ::v-deep .v-input__slot {
  background: rgba(15, 23, 42, 0.03) !important;
  border-color: rgba(15, 23, 42, 0.08) !important;
  min-height: 36px !important;
  font-family: poppinsmedium, sans-serif !important;
  font-size: 13px !important;
  transition: all 0.25s ease;
}
.year-select ::v-deep .v-input__slot:hover {
  border-color: rgba(222, 82, 12, 0.35) !important;
  background: rgba(222, 82, 12, 0.04) !important;
}
.year-select ::v-deep .v-select__selection {
  color: #0f172a !important;
  font-weight: 600;
}

/* Highcharts polish */
::v-deep .highcharts-background {
  fill: transparent;
}
::v-deep .highcharts-grid-line {
  stroke: rgba(15, 23, 42, 0.04);
}
::v-deep .highcharts-tooltip-box {
  filter: drop-shadow(0 4px 12px rgba(15, 23, 42, 0.15));
}
::v-deep .highcharts-legend-item text {
  fill: #334155 !important;
}
::v-deep .highcharts-legend-item:hover text {
  fill: #de520c !important;
}
::v-deep .highcharts-point {
  transition: transform 0.2s ease;
}

/* Chart and general container Cards */
.chart-card {
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.5) !important;
  border-radius: 16px !important;
  box-shadow: 0 10px 40px -10px rgba(0, 0, 0, 0.06) !important;
  transition: all 0.6s cubic-bezier(0.16, 1, 0.3, 1) !important;
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(12px);
}

.chart-card.card-cases {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%) !important;
  border: 1px solid rgba(15, 23, 42, 0.08) !important;
}
.chart-card.card-cases:hover {
  box-shadow: 0 25px 35px -5px rgba(15, 23, 42, 0.12), 0 15px 15px -5px rgba(15, 23, 42, 0.06) !important;
  border-color: rgba(222, 82, 12, 0.3) !important;
}

.chart-card.card-species {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%) !important;
  border: 1px solid rgba(15, 23, 42, 0.08) !important;
}
.chart-card.card-species:hover {
  box-shadow: 0 25px 35px -5px rgba(15, 23, 42, 0.12), 0 15px 15px -5px rgba(15, 23, 42, 0.06) !important;
  border-color: rgba(222, 82, 12, 0.3) !important;
}

.chart-card.card-leaderboard {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%) !important;
  border: 1px solid rgba(15, 23, 42, 0.08) !important;
}
.chart-card.card-leaderboard:hover {
  box-shadow: 0 25px 35px -5px rgba(15, 23, 42, 0.12), 0 15px 15px -5px rgba(15, 23, 42, 0.06) !important;
  border-color: rgba(222, 82, 12, 0.3) !important;
}

/* Sliding Shine on Chart Cards */
.chart-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 150%;
  height: 100%;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(222, 82, 12, 0.04) 25%,
    rgba(222, 82, 12, 0.08) 50%,
    rgba(222, 82, 12, 0.04) 75%,
    rgba(255, 255, 255, 0) 100%
  );
  transform: translateX(-110%) skewX(-20deg);
  transition: none;
  z-index: 1;
  pointer-events: none;
}

.chart-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 25px 35px -5px rgba(222, 82, 12, 0.08), 0 15px 15px -5px rgba(222, 82, 12, 0.04) !important;
  border-color: rgba(222, 82, 12, 0.3) !important;
}

.chart-card:hover::before {
  transform: translateX(110%) skewX(-20deg);
  transition: transform 1.8s cubic-bezier(0.16, 1, 0.3, 1);
}

/* Interactive item lists (e.g. top rescuers) */
::v-deep .v-card {
  overflow: hidden;
}
</style>